<template>
  <section id="map" style="margin-top: 14.5394vw;">
    <div class="map">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 918 1112">
            <path fill="#222" fill-rule="nonzero" d="M38.594 0l351.189 28.146-14.991 330.057 494.025 464.566s0 17.982 3.934 22.64c3.935 4.657 13.444 10.939 15.74 15.597 2.404 4.657-.002 17.223 3.933 21.88 3.935 4.658 25.576 15.597 25.576 15.597s-7.433 10.183-11.368 14.083c-3.935 3.9-18.91 11.7-22.08 18.74-3.17 7.042-3.937 25.023-2.407 32.064 1.53 7.04 3.17 17.981 0 21.123-3.17 3.141-9.51 10.94-12.68 13.324-3.17 2.383-6.34 2.383-5.575 6.283.765 3.9 7.87 8.557 7.869 14.081 0 5.525-4.7 13.324-4.701 20.365 0 7.04 3.934 10.94 11.039 11.698 7.104.758 17.38-1.517 15.74 5.524-1.531 7.04-7.872 23.506-13.446 26.54-5.575 3.14-12.68 0-12.68 0L627.353 1112s-3.17-18.631-7.104-24.155c-3.934-5.525-6.339-10.182-5.573-15.598.765-5.525-8.634-31.305-13.443-40.62-4.808-9.316-29.947-27.404-34.756-32.062-4.7-4.657-60.006-31.302-60.006-31.302s-3.578-4.893-8.664-11.915c-5.086-7.023-2.194-10.832-8.381-14.116-6.188-3.283-15.307-2.889-15.307-2.889s-15.74-6.282-20.549-7.798c-4.81-1.516-21.314-4.657-23.718-8.556-2.405-3.9-16.613-26.538-31.587-29.679-14.975-3.14-22.08-3.898-27.654-3.14-5.574.759-11.04-1.516-17.379-4.657-6.34-3.14-27.653-3.898-35.523-2.381l-7.87 1.517-15.738-22.638 6.34-8.558-7.105-9.424 7.106-8.558-8.635-9.423 8.635-7.8-5.573-12.565s3.17-3.141 2.405-7.04c-.765-3.9-8.635-6.283-11.805-5.525-3.17.759-11.039-7.798-11.804-13.323-.765-5.524 6.34-3.9 7.105-7.04.765-3.142-5.574-12.566-11.039-14.082-5.574-1.516-8.635 1.517-14.974-10.182-6.339-11.698-.764-14.84-7.869-15.597-7.104-.758-7.87-1.517-11.804-10.182-3.934-8.557-10.274-7.799-13.443-17.223-3.17-9.423 6.34-7.799 2.405-11.698-3.935-3.9-16.613-16.464-21.313-20.364-4.7-3.9-16.613-17.222-16.613-17.222l-2.403-35.963s5.574 3.141 10.274-3.142l4.7-6.282s6.34-2.384 3.936-8.558c-2.404-6.174-9.509-11.698-9.509-11.698s2.405-2.384-.764-6.283c-3.17-3.9-17.38-2.382-17.38-2.382l-28.417-27.512s-2.405.108 0-12.782c2.406-12.89 8.636-14.516 5.576-19.174-3.06-4.657-10.274-12.564-11.804-20.363-1.53-7.8-1.529-15.599 3.936-14.84 5.575.757 11.804 14.839 18.144 17.98 6.339 3.14 4.7 3.14 12.678 8.557 7.87 5.524-2.404-1.517-7.869-13.324-5.574-11.698-9.508-16.464-7.103-23.505 2.405-7.041 5.574-9.424 7.105-13.324 1.53-3.9-.765-8.557-6.34-4.657-5.574 3.9-5.574 7.799-7.105 13.323-1.53 5.525-3.935 10.941-7.87 10.941s-14.974-12.564-20.548-14.839c-5.575-2.383-9.51-12.565-14.21-12.564-4.7 0-10.273-1.516-10.273-1.516l8.635-14.84s-5.574-10.183-8.634-13.324c-3.17-3.141-7.104-5.524-7.87-12.565-.764-7.04-.764-10.94-.764-10.94s-15.74-3.9-19.783-13.323c-4.044-9.424-3.934-14.081-10.273-21.122-6.34-7.04-13.444-8.557-16.614-17.222-3.169-8.558 3.171-21.881.002-29.68-3.17-7.8-7.87-9.424-7.104-19.606.766-10.183 11.04-21.882 9.511-28.923-1.53-7.04-16.612-37.586-17.377-39.861-.765-2.275 0-12.565 0-12.565S0 198.664 0 193.139c0-5.524 3.17-8.557 4.7-12.565 1.531-3.9-4.699-7.8-4.699-7.8s11.041-31.305 14.976-34.446c3.935-3.142 8.635 2.383 11.04-3.142l2.405-5.525-3.935-1.516s7.87-14.84 9.51-19.607c1.64-4.766-7.104-10.94-4.699-17.222 2.405-6.283 11.04-14.841 13.446-28.165 2.405-13.323-5.573-34.446-9.507-37.587-3.935-3.141-2.405-10.94-2.405-10.94L38.594 0z"></path>
        </svg>
    </div>
    <div id="fire-0" class="wildfire">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 20">
            <path fill="none" fill-rule="evenodd" stroke="#FFF" d="M12 .972L.883 19.5h22.234L12 .972z"></path>
        </svg>
    </div>
    <div id="fire-1" class="wildfire">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 20">
            <path fill="none" fill-rule="evenodd" stroke="#FFF" d="M12 .972L.883 19.5h22.234L12 .972z"></path>
        </svg>
    </div>
    <div id="fire-2" class="wildfire">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 20">
            <path fill="none" fill-rule="evenodd" stroke="#FFF" d="M12 .972L.883 19.5h22.234L12 .972z"></path>
        </svg>
    </div>
    <div id="fire-3" class="wildfire">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 20">
            <path fill="none" fill-rule="evenodd" stroke="#FFF" d="M12 .972L.883 19.5h22.234L12 .972z"></path>
        </svg>
    </div>
    <div id="fire-4" class="wildfire">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 20">
            <path fill="none" fill-rule="evenodd" stroke="#FFF" d="M12 .972L.883 19.5h22.234L12 .972z"></path>
        </svg>
    </div>
    <div id="fire-5" class="wildfire">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 20">
            <path fill="none" fill-rule="evenodd" stroke="#FFF" d="M12 .972L.883 19.5h22.234L12 .972z"></path>
        </svg>
    </div>
    <div id="fire-6" class="wildfire">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 20">
            <path fill="none" fill-rule="evenodd" stroke="#FFF" d="M12 .972L.883 19.5h22.234L12 .972z"></path>
        </svg>
    </div>
    <div id="fire-7" class="wildfire">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 20">
            <path fill="none" fill-rule="evenodd" stroke="#FFF" d="M12 .972L.883 19.5h22.234L12 .972z"></path>
        </svg>
    </div>
    <div id="fire-8" class="wildfire">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 20">
            <path fill="none" fill-rule="evenodd" stroke="#FFF" d="M12 .972L.883 19.5h22.234L12 .972z"></path>
        </svg>
    </div>
    <div id="fire-9" class="wildfire">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 20">
            <path fill="none" fill-rule="evenodd" stroke="#FFF" d="M12 .972L.883 19.5h22.234L12 .972z"></path>
        </svg>
    </div>
    <div id="fire-10" class="wildfire">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 20">
            <path fill="none" fill-rule="evenodd" stroke="#FFF" d="M12 .972L.883 19.5h22.234L12 .972z"></path>
        </svg>
     </div>
     <div id="fire-11" class="wildfire">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 20">
            <path fill="none" fill-rule="evenodd" stroke="#FFF" d="M12 .972L.883 19.5h22.234L12 .972z"></path>
        </svg>
     </div>
     <div id="fire-12" class="wildfire">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 20">
            <path fill="none" fill-rule="evenodd" stroke="#FFF" d="M12 .972L.883 19.5h22.234L12 .972z"></path>
        </svg>
     </div>
     <div id="fire-13" class="wildfire">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 20">
            <path fill="none" fill-rule="evenodd" stroke="#FFF" d="M12 .972L.883 19.5h22.234L12 .972z"></path>
        </svg>
     </div>
     <div id="fire-14" class="wildfire">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 20">
            <path fill="none" fill-rule="evenodd" stroke="#FFF" d="M12 .972L.883 19.5h22.234L12 .972z"></path>
        </svg>
     </div>
     <div id="fire-15" class="wildfire">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 20">
            <path fill="none" fill-rule="evenodd" stroke="#FFF" d="M12 .972L.883 19.5h22.234L12 .972z"></path>
        </svg>
     </div>
     <div id="fire-16" class="wildfire">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 20">
            <path fill="none" fill-rule="evenodd" stroke="#FFF" d="M12 .972L.883 19.5h22.234L12 .972z"></path>
        </svg>
     </div>
     <div id="fire-17" class="wildfire">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 20">
            <path fill="none" fill-rule="evenodd" stroke="#FFF" d="M12 .972L.883 19.5h22.234L12 .972z"></path>
        </svg>
     </div>
     <div id="fire-18" class="wildfire">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 20">
            <path fill="none" fill-rule="evenodd" stroke="#FFF" d="M12 .972L.883 19.5h22.234L12 .972z"></path>
        </svg>
     </div>
     <div id="fire-19" class="wildfire">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 20">
            <path fill="none" fill-rule="evenodd" stroke="#FFF" d="M12 .972L.883 19.5h22.234L12 .972z"></path>
        </svg>
     </div>
     <div id="fire-20" class="wildfire">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 20">
            <path fill="none" fill-rule="evenodd" stroke="#FFF" d="M12 .972L.883 19.5h22.234L12 .972z"></path>
        </svg>
     </div>
     <div id="fire-21" class="wildfire">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 20">
            <path fill="none" fill-rule="evenodd" stroke="#FFF" d="M12 .972L.883 19.5h22.234L12 .972z"></path>
        </svg>
     </div>
     <div id="fire-22" class="wildfire">
       <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 20">
            <path fill="none" fill-rule="evenodd" stroke="#FFF" d="M12 .972L.883 19.5h22.234L12 .972z"></path>
        </svg>
     </div>
     <div id="fire-23" class="wildfire">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 20">
            <path fill="none" fill-rule="evenodd" stroke="#FFF" d="M12 .972L.883 19.5h22.234L12 .972z"></path>
        </svg>
     </div>
     <div id="fire-24" class="wildfire">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 20">
            <path fill="none" fill-rule="evenodd" stroke="#FFF" d="M12 .972L.883 19.5h22.234L12 .972z"></path>
        </svg>
     </div>
     <div id="SF" class="office">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
            <circle cx="284" cy="514" r="6" fill="#FFF" fill-rule="evenodd" transform="translate(-278 -508)"></circle>
        </svg>
     </div>
     <div id="LA" class="office">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
            <circle cx="284" cy="514" r="6" fill="#FFF" fill-rule="evenodd" transform="translate(-278 -508)"></circle>
        </svg>
     </div>
   </section>
</template>

<script>
export default {
  name: 'Map'
}
</script>

<style>
.office svg, .wildfire svg{
  width: 3vw;
}
</style>

<style scoped>
section{
  position: relative;
}

/*@media screen and (max-width: 991px) and (min-width: 768px){
  section {
    margin-left: 0;
    width: 120%;
  }
}*/
@media screen and (max-width: 991px){
  section {
    width: 134%;
  }
}
.office, .wildfire{
  position: absolute;
  z-index: 5;
}


#fire-0 {
    top: 0;
}
#fire-1 {
    top: 2%;
}
#fire-0, #fire-1, #fire-3, #fire-4 {
    left: 18.5%;
}
#fire-2 {
    top: 6.4%;
}
#fire-2, #fire-19 {
    left: 34.4%;
}
#fire-3, #fire-5 {
    top: 11%;
}
#fire-4, #fire-6 {
    top: 13%;
}
#fire-5, #fire-6, #fire-14, #fire-15, #fire-16 {
    left: 21.25%;
}
#fire-7 {
    top: 25%;
}
#fire-7, #fire-8 {
    left: 25%;
}
#fire-8, #fire-9 {
    top: 27%;
}
#fire-9, #fire-10, #fire-11 {
    left: 11.25%;
}
#fire-10, #fire-12 {
    top: 29%;
}
#fire-11, #fire-13 {
    top: 31%;
}
#fire-12, #fire-13 {
    left: 14%;
}
#fire-14 {
    top: 33.5%;
}
#fire-15 {
    top: 35.5%;
}
#fire-16, #fire-17, #fire-18 {
    top: 37.5%;
}
#fire-17 {
    left: 38.75%;
}
#fire-18 {
    left: 41.5%;
}
#fire-19, #fire-20, #fire-21 {
    top: 44.5%;
}
#fire-20 {
    left: 45.25%;
}
#fire-21, #fire-22, #fire-23 {
    left: 48%;
}
#fire-22 {
    top: 79.25%;
}
#fire-23, #fire-24 {
    top: 81.25%;
}
#fire-24 {
    left: 50.5%;
}
#SF {
    top: 44.5%;
    left: 15%;
}
#LA {
    top: 83.75%;
    left: 54.75%;
}
</style>
